import { IHttpPromise, IHttpService } from 'angular';

export interface IZippotamPlace {
    'place name': string;
    longitude: string;
    state: string;
    'state abbreviation': string;
    latitude: string;
}

export interface IZippotamResponse {
    'post code': string;
    country: string;
    'countrty abbreviation': string;
    places: IZippotamPlace[];
}

export default class BillingService {
    static $inject = ['$http'];
    constructor(protected $http: IHttpService) {}

    /**
     * @param {String} country - abbreviation country zipcode is in. e.g. us
     * @param {String} zipcode - zipcode. e.g. 11221
     * Lookup data provided by www.zippopotam.us, utilizing info from geonames.org
     */
    zipcodeLookup(country: string, zipcode: string): IHttpPromise<IZippotamResponse> {
        return this.$http.get<IZippotamResponse>('//api.zippopotam.us/' + country + '/' + zipcode);
    }
}
